const orderMixin = {
  methods: {
    /**
     * Return current order of transport item inside transport
     * can have "totalItems" if a transport is split into ongoing and completed missions
     */
    makeTransportOrder(card, totalItems = null) {
      let length = totalItems
        ? totalItems
        : Object.keys(this.mission.transport_items).length;

      return length > 1 ? card.order + '/' + length : '';
    },

    makeMissionOrder() {
      return this.mission.order ? 'Mission ' + this.mission.order : '';
    },
  },
};

export { orderMixin };
